import { authActions } from '../actions'
const { FETCH_AUTH, FETCHING_AUTH, FETCH_AUTH_ERROR, CLEAR_AUTH, CHANGE_STATE_AREA, STOP_FETCHING } = authActions

const initialState = {
  userName: '',
  areaName: '',
  areaCode: '',
  areaId: '',
  areaResponsible: '',
  businessUnitResponsible: '',
  canChangeArea: '',
  is_fetching: false,
  fetch_error: false,
  fetch_error_message: '',
  permissions: [],
  profile_document_url: ''
}

const auth = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_AUTH:
      return {
        ...initialState,
        is_fetching: true
      }

    case FETCH_AUTH:
      return {
        ...state,
        userName: action.userName,
        areaName: action.areaName,
        areaCode: action.areaCode,
        areaId: action.areaId,
        areaResponsible: action.areaResponsible,
        businessUnitResponsible: action.businessUnitResponsible,
        canChangeArea: action.canChangeArea,
        permissions: action.permissions,
        profile_document_url: action.profile_document_url,
        is_fetching: false,
        fetch_error: false,
        fetch_error_message: ''
      }

    case FETCH_AUTH_ERROR:
      return {
        ...initialState,
        fetch_error: true,
        fetch_error_message: action.error
      }

    case CLEAR_AUTH:
      return initialState

    case STOP_FETCHING:
      return {
        ...state,
        is_fetching: false
      }

    case CHANGE_STATE_AREA:
      return { 
        ...state, 
        areaName: action.areaName,
        areaCode: action.areaCode,
        areaId: action.areaId, 
        areaResponsible: action.areaResponsible, 
        businessUnitResponsible: action.businessUnitResponsible 
      }

    default:
      return state
  }
}

export default auth



// WEBPACK FOOTER //
// ./src/reducers/auth.js